import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const normalizeRoles = (user) => {
  const fromJoin = Array.isArray(user?.roles) ? user.roles.map((r) => r?.name).filter(Boolean) : []
  const legacy = Array.isArray(user?.role) ? user.role.filter(Boolean) : user?.role ? [user.role] : []
  return Array.from(new Set([...legacy, ...fromJoin]))
}

/**
 * Route guard requiring authentication plus at least one allowed role.
 */
export default function RoleRoute({ children, roles = [], requireAdmin = false, fallback = '/tickets/hub' }) {
  const { isAuthenticated, user, loading } = useAuth()
  const location = useLocation()

  if (loading) return null
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />

  const userRoles = normalizeRoles(user)
  const isAdmin = userRoles.includes('Admin') || userRoles.includes('SuperAdmin')
  if (requireAdmin && !isAdmin) return <Navigate to={fallback} replace />
  if (roles.length && !roles.some((r) => userRoles.includes(r)) && !isAdmin) {
    return <Navigate to={fallback} replace />
  }

  return children
}
